import { apiClient } from '@src/services/http-common'
import type { User, UserDtoFromJwt, UserRight, UserRights } from '@src/types/user'
import { omit } from 'lodash-es'
import { createContext } from 'react'

export interface UserStore {
  user: User
}

export function parseJwt(token: string): object {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => {
        return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`
      })
      .join(''),
  )

  const payload = JSON.parse(jsonPayload) as { isBannerUser?: string | boolean }

  if (payload.isBannerUser !== undefined) {
    payload.isBannerUser = payload.isBannerUser === 'True'
  }

  return payload
}

export function isExpiredToken(expiryDate: number): boolean {
  const date = new Date().valueOf() / 1000
  return date > expiryDate
}

function buildRights(jwtRights: UserRight[]): UserRights {
  const ret = {} as UserRights
  jwtRights.forEach((r: UserRight) => {
    ret[r] = true
  })
  return ret
}

export function loadUserFromJwtString(jwtToken: string | null): User | null {
  if (!jwtToken) return null
  const dto = parseJwt(jwtToken) as UserDtoFromJwt

  const user: User = {
    ...omit(dto, ['roles', 'rights']),
    isInternal: dto.isInternal === 'true',
    roles: dto.roles.split(','),
    rights: buildRights(dto.rights.split(',') as UserRight[]),
  }

  if (isExpiredToken(user.exp)) return null

  apiClient.defaults.headers.common.Authorization = `Bearer ${jwtToken}`
  return user
}

export const UserContext = createContext<UserStore | null>(null)

export const JWT_LOCAL_STORAGE_KEY = 'userToken'
export const CACHED_USER_TOKEN = localStorage.getItem(JWT_LOCAL_STORAGE_KEY)
